module.exports = __webpack_public_path__ + "img/using.172bef6.172bef66.png";